var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "data-name": "Layer 1",
    viewBox: "0 0 128 128"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118.12,
    height: 118.12,
    x: 4.95,
    y: 4.46,
    className: "twitter_svg__cls-1",
    rx: 59.06
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.2 56.51a2.6 2.6 0 0 1 .22-3.24c14.64-16 19-21.17 20.39-23.26l3-3.37h-7.47a2.52 2.52 0 0 0-1.94.9c-2.23 2.65-8.84 10-17.36 19.29a2.56 2.56 0 0 1-4-.22l-14-19.49A2.54 2.54 0 0 0 53 26.06H29.16a2.55 2.55 0 0 0-2.11 4L52 66.86a2.55 2.55 0 0 1-.24 3.14L32.81 90.55l-2.78 3-4.26 4.62h8.13a2.6 2.6 0 0 0 1.89-.84c7.18-7.76 13.5-14.59 19.1-20.66a2.53 2.53 0 0 1 4 .32l14.29 21.16a2.56 2.56 0 0 0 2.11 1.12H102a2.55 2.55 0 0 0 2.07-4Zm-14.41 12.7-3.93-5.81-18-26.57a2.55 2.55 0 0 1 2.11-4h7.53a2.57 2.57 0 0 1 2.07 1.06l14.66 20.39L70.3 60l20.5 28.43a2.55 2.55 0 0 1-2.07 4h-9.84a2.56 2.56 0 0 1-2.11-1.12Z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgTwitter;